<template>
  <div>
    <v-list-item v-for="(item, index) in list"
                 :key="'posts_help_'+index"
                 :to="{name: 'post', params: {id: item.id}}"
    >
      <v-list-item-icon>
        <v-icon color="primary">mdi-help-circle-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{item.name}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: 'Posts',
  props: ['list'],
  data: () => ({

  }),
}
</script>